import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Table } from '@yuhuinc/ui-library';

import { getTranslatedString } from 'helpers/i18n';

const StyledTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  overflow-x: ${(props) => (props.isMobile ? 'scroll' : 'hidden')};
`;

const StyledBoldLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
`;

const AssignUnitTable = ({
  isMobile,
  dataSource,
  columns,
  hideActionAndSearch,
  onChange,
  rowSelection,
  pagination,
  loading,
}) => {
  return (
    <StyledTableContainer isMobile={isMobile}>
      <StyledBoldLabel>
        {getTranslatedString(
          'landlordPortal.applicationManagement.inviteLeadToApply.availableUnitsAtSelectedProperty'
        )}
      </StyledBoldLabel>
      <Table
        dataSource={dataSource}
        columns={columns}
        hideActionAndSearch={hideActionAndSearch}
        onChange={onChange}
        rowSelection={rowSelection}
        pagination={pagination}
        loading={loading}
        size={isMobile ? 'middle' : 'small'}
        scroll={{
          x: isMobile,
        }}
      />
    </StyledTableContainer>
  );
};

AssignUnitTable.propTypes = {
  isMobile: PropTypes.bool,
  dataSource: PropTypes.array,
  columns: PropTypes.array,
  hideActionAndSearch: PropTypes.bool,
  onChange: PropTypes.func,
  rowSelection: PropTypes.object,
  pagination: PropTypes.object,
  loading: PropTypes.bool,
};

export default AssignUnitTable;
